module.exports = __webpack_public_path__ + "media/dealer/dealerTab2-af728c74.jpg";